export enum FileStorageLocation
{
    AWS = 1,
    AbsoluteURL = 2,
    RelativeURL = 3
}
